import {
    Accordion,
    Button,
    Card,
    Col,
    Container,
    Form,
    Row,
    Toast,
} from "react-bootstrap";
import { faCaretDown, faCaretUp, faEye, faPen, faPrint } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcons } from "@dcam/dcam_flhealth_component_library";
import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
} from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { apiConfig } from "../../authConfig";
import apiClient from "../../client/ApiGetClient";
import useData from "../../hooks/useData";
import usePostData from "../../hooks/usePostData";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Console } from "console";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import {
    CaseReportFormRequest,
    ClientSearchResult,
    ClientUpdateRequest,
    DiagnosisDetail,
    SearchInfoRequest,
    SearchLabRequest,
    SelectOption,
} from "../../types";

import usePost from "../../hooks/usePost";
import useGetData from "../../hooks/useGetData";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApiResponse } from "../Dashboard/ApiResponse";
//import ".ProviderDashboard/ProviderDashboard.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { set } from "date-fns";
import EditUser from "./EditUser";
import { useNavigate } from "react-router-dom";


const UserDashboard: React.FC = () => {

    const { instance, accounts } = useMsal();

    const account = accounts[0];
    const [isUserFormEnable, setUserFormEnable] = useState(false);
    const [email, setUserEmail] = useState("");
    const navigate = useNavigate();
    const [loggedInUserRole, setLoggedInuserRole] = useState("");

    const canEditUser = (selectedUserRole: string): boolean => {
        if (loggedInUserRole === "Provider" && selectedUserRole === "Admin") {
            return false;
        }
        if (loggedInUserRole === "HIV Provider") {
            const allowedRoles = ["HIV Provider", "HIV Staff"];
            return allowedRoles.includes(selectedUserRole);
        }
        if (loggedInUserRole === "STD Provider") {
            const allowedRoles = ["STD Provider", "STD Staff"];
            return allowedRoles.includes(selectedUserRole);
        }
        return true;
    }
    const clickHandler = (row: any) => {
        if (!canEditUser(row.roleName)) {
            toast.error("You are not allowed to edit user information.", {
                position: "top-right",
                autoClose: 2000,
            });
            return;
        }

        setUserFormEnable(true);
        setUserEmail(row.email);
        /// console.log(row);
    }

    const UserColumn = [
        {
            name: <b>First Name</b>,
            selector: (row: any) => row.firstName,
        },
        {
            name: <b>Last Name</b>,
            selector: (row: any) => row.lastName,
        },
        {
            name: <b>Email</b>,
            selector: (row: any) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                {row.email}
            </div>,
            width: "280px",
        },
        {
            name: <b>Role</b>,
            selector: (row: any) => row.roleName,
            width: "100px",
        },
        {
            name: <b>Hospital/Location</b>,
            selector: (row: any) =>
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {row.routinizedHospitalName ?
                        <div>
                            {row.routinizedHospitalName ? `${row.routinizedHospitalName}` : "-"}
                            <br></br>
                            {row.routinizedHospitalName ? <>&emsp;&emsp;- {row.routinizedFacilityName}</> : ""}
                        </div>
                        : "-"}

                </div>,
            sortable: true,
            width: "250px",
        },
        {
            name: <b>Status</b>,
            selector: (row: any) => row.isActive ? "Active" : "Inactive",
            width: "100px",
        },


        {
            name:  <b style={{ display: "block", marginLeft: "20px", width: "100%" }}>Action</b>,
            selector: (row: any) =>
                <div>
                    <AppButton
                        variant={"secondary"}
                        onClick={() => clickHandler(row)}
                    >
                        <FontAwesomeIcon icon={faPen} /> &nbsp;
                        Edit
                    </AppButton>
                </div>,
            //width: "100px",
        },
    ];

    const [userData, setUserData] = useState<any>();

    const { getDataById: getAllUserSecurity } = useGetData<any, string>(
        "UserSecurity/GetAllUserSecurity",
        "GET"
    );

    const { getDataById: getAllClients } = useGetData<any, string>(
        "Client/GetAllClients",
        "GET"
    );

    const { getDataById: getUserId } = useGetData<any, string>(
        "UserSecurity/GetUserSecurityByEmail/" + account.username,
        "GET"
    );

    useEffect(() => {
        const loadData = async () => {
            const data = await getAllUserSecurity("");
            setUserData(data)
            if (data) {
                const userData = await getUserId("");
                setLoggedInuserRole(userData?.user?.roleName);
                if (!userData?.user?.isActive) {
                    navigate('/unauthorized');
                }
                else {
                    if (userData?.user?.roleName != "Admin") {
                        if (userData) {
                            let filterData = data?.filter((x: { routinizedHospitalId: any; }) => x.routinizedHospitalId == userData?.user?.routinizedHospitalId);
                            setUserData(filterData)
                        }
                    }
                    if (userData?.user?.roleName === "Staff") {
                        navigate("/dashboard");
                    }
                }
            }
        };
        loadData();
    }, []);

    const handleBackButton = () => {
        setUserFormEnable(false);
        handleSearch('');
    }

    // const [clientData, setClientData] = useState<any>([]);
    const [filteredData, setFilteredData] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [roleName, setRoleName] = useState<string>("");


    const handleSearch = (searchValue: string) => {
        setSearchTerm(searchValue);
        const lowercasedValue = searchValue.toLowerCase();
        searchValue = searchValue.toLowerCase();
        if (!searchValue) {
            setFilteredData(userData);
            return;
        }

        const filtered = userData?.filter((row: any) => {
            const isActiveText = row?.isActive ? "Active" : "Inactive";

            return (
                row?.firstName?.toLowerCase().search(searchValue) >= 0 ||
                row?.lastName?.toLowerCase().search(searchValue) >= 0 ||
                row?.email?.toLowerCase().search(searchValue) >= 0 ||
                row?.roleName?.toLowerCase().search(searchValue) >= 0 ||
                row?.routinizedHospitalName?.toLowerCase().search(searchValue) >= 0 ||
                isActiveText.toLowerCase().search(searchValue) >= 0
            );
        });

        setFilteredData(filtered);
    };

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const data = await getAllUserSecurity("");
        setUserData(data);
        if (data) {
            // Set the original data
            setFilteredData(data); // Initialize the filtered data to show all rows initially
            const userData = await getUserId("");
            if (userData?.user?.roleName) {
                setRoleName(userData.user.roleName);
            }
            if (userData?.user?.roleName !== "Admin") {
    let filterData = data.filter(
        (x: { routinizedHospitalId: any }) =>
            x.routinizedHospitalId === userData?.user?.routinizedHospitalId
    );

    switch (userData?.user?.roleName) {
        case "Program Admin":
            // Can see Program Admin and below
            filterData = filterData.filter(
                (x: any) =>
                    !["Admin"].includes(x.roleName)
            );
            break;

        case "HIV Program Admin":
            // Can see HIV Program Admin, HIV Provider, HIV Staff
            filterData = filterData.filter(
                (x: any) =>
                    ["HIV Program Admin", "HIV Provider", "HIV Staff"].includes(x.roleName)
            );
            break;

        case "STD Program Admin":
            // Can see STD Program Admin, STD Provider, STD Staff
            filterData = filterData.filter(
                (x: any) =>
                    ["STD Program Admin", "STD Provider", "STD Staff"].includes(x.roleName)
            );
            break;

        case "HIV Provider":
            filterData = filterData.filter(
                (x: any) =>
                    ["HIV Provider", "HIV Staff"].includes(x.roleName)
            );
            break;

        case "STD Provider":
            filterData = filterData.filter(
                (x: any) =>
                    ["STD Provider", "STD Staff"].includes(x.roleName)
            );
            break;
    }

    setUserData(filterData);
    setFilteredData(filterData);
}
        }
    };

    const handleSave = ()=> {
        loadData();
        handleBackButton();
    }

    return (
        <>
            <Container>
                {!isUserFormEnable ?
                    <div >

                        {/* <AppCard title="Florida Heath Care Lookup Dashboard"> */}

                        <Row className="mb-3">
                            <Col>
                                <br></br>
                                <AppCard title="User Dashboard" bottomMargin>
                                    <Row>
                                        <Col >
                                            <AppDataTable
                                                columns={UserColumn}
                                                data={filteredData}
                                                pagination={true}
                                                search={true}
                                                searchCallBack={handleSearch}
                                                //loading={isProgress}
                                                noDataComponent={undefined}
                                            />
                                        </Col>
                                    </Row>
                                </AppCard>
                            </Col>
                        </Row>
                        {/* </AppCard> */}
                    </div> :
                    <EditUser email={email} onClick={handleBackButton} handleSave={handleSave}></EditUser>}

            </Container>
        </>
    );
};

export default UserDashboard;